import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const SubjectByStandardApi = createApi({
  reducerPath: 'subjectByStandardApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  endpoints: (builder) => ({
    getSubjectByStandard: builder.mutation({
      query: (values, signal) => ({
        url: `${process.env.REACT_APP_API_URL}/subject/dataByStandard`,
        method: 'POST',
        signal,
        redirect: 'follow',
        body: { ...values },
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': 'admin.infopublisher.in',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
          'Access-Control-Allow-Headers':
            'Access-Control-Allow-Headers, Access-Control-Allow-Methods, Access-Control-Allow-Origin, Access-Control-Allow-Credentials, Origin, X-Requested-With, Content-Type, Accept, Authorization, access-control-allow-credentials,access-control-allow-headers,access-control-allow-methods,access-control-allow-origin,content-type',
          'Access-Control-Allow-Credentials': 'true',
        },
      }),
    }),
  }),
});

export const { useGetSubjectByStandardMutation } = SubjectByStandardApi;

export const { SubjectByStandardApiReducer } = SubjectByStandardApi.reducer;
